export { default } from './EventFooter';
